import { API, graphqlOperation } from 'aws-amplify';
//import { createCompany, updateCompany, deleteCompany } from './graphql/mutations';
//import { listCompanys } from './graphql/queries';

export default {
    namespaced:true,
    state: {
        entity: 'Company',
        list: null,
        item: null,
        nextToken: null,
        prefill: {}
    },
    mutations: {
        list: (state, payload) => { state.list = payload.append ? (state.list || []).concat(payload.value) : payload.value },
        item: (state, payload) => { state.item = payload.value },
        nextToken: (state, payload) => { state.nextToken = payload.value },
        prefill: (state, payload) => { state.prefill = Object.assign(state.prefill, payload)}
    },
    getters: {
       isActive: (state) => state.item ? state.item.active == 'ACTIVE' : true,
       isTrial: (state) => state.item?.active == 'ACTIVE' && !state.item?.hasStripeSubscription && !state.item?.hasManualInvoicing,
       isDowngraded: (state) => state.item?.activeSubscription?.monthlyUserLimit > state.item?.paymentInformation?.activePlan,
       isBlocked: (state) => state.item?.active == 'PAYMENT_DUE' || state.item?.active == 'OVER_LIMIT',
       subscription: (state) => state.item?.activeSubscription ?? { from: null, to: null, monthlyUserLimit: null },
       stats: (state) => state.item?.stats ?? { monthlyUsers: null, dreamroiSales: null }

    },
    actions: {
        async get(context, payload) {
            const c = await API.graphql(graphqlOperation(/* GraphQL */ ` query GetCompany($id: ID!) {
              getCompany(id: $id) {
                id
                name
                email
                phone
                street
                city
                active
                zip
                country
                crNo
                vatNo
                vatPayer
                owner
                editors
                accessRights {
                  cognitoID
                  email
                  role
                }
                activeSubscription {
                  from
                  to
                  monthlyUserLimit
                }
                stats {
                  monthlyUsers
                  dreamroiSales
                  emailsSent
                }
                hasStripeSubscription
                #payment information is queried separately due to access rights
                #paymentInformation {
                #  activePlan
                #}
                hasManualInvoicing
                createdAt
              }}
                `, { id: payload.id }));
            
            context.commit('item', {value: c.data.getCompany });

        },
        
        async list(context, payload) {
            const c = await API.graphql(graphqlOperation(`
            query ListCompanies(
              $filter: ModelCompanyFilterInput
              $limit: Int
              $nextToken: String
            ) {
              listCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
                items {
                  id
                  email
                  name
                  active
                  street
                  city
                  zip
                  country
                  owner
                  activeSubscription {
                    from
                    to
                    monthlyUserLimit
                  }
                  stats {
                    monthlyUsers
                    dreamroiSales
                    emailsSent
                  }
                }
                nextToken
              }
            }
          `, payload));
            context.commit('list', {value: c.data.listCompanys.items, append: !!payload?.nextToken });
            context.commit('nextToken', {value: c.data.listCompanys.nextToken });
            if(context.state.nextToken) {
              await context.dispatch('list', { nextToken: context.state.nextToken });
            }
        },

        async create(context, payload) {
          var reqparams = {
            accessRightsSecret: await context.dispatch('generateSecret', null, {root: true}),
            active: 'ACTIVE',
            activeSubscription: {
              from: new Date(),
              to: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
              monthlyUserLimit: 10000
            },
            stats: {
              monthlyUsers: 0,
              dreamroiSales: 0
            }
          }
          Object.assign(payload, reqparams);
          var r = await API.graphql(graphqlOperation(`
            mutation CreateCompany(
              $input: CreateCompanyInput!
              $condition: ModelCompanyConditionInput
            ) {
              createCompany(input: $input, condition: $condition) {
                id
              }
            }
          `, { input: payload}));
          return r.data.createCompany;
        },

        async remove(context, payload) {
          let dq = await API.graphql(graphqlOperation(/* GraphQL */ `
          query GetCompany($id: ID!) {
              getCompany(id: $id) {
                id
                domains {
                  items {
                    id
                  }
                }
              }
          }
          `, { id: payload.id }));
          if(dq.data.getCompany.domains.items.length > 0) {
            return;
          }
          await API.graphql(graphqlOperation(/* GraphQL */ `
          mutation DeleteCompany(
            $input: DeleteCompanyInput!
            $condition: ModelCompanyConditionInput
          ) {
            deleteCompany(input: $input, condition: $condition) {
              id
            }
          }
          `, { input: { id: payload.id } }));
        },

        async updateFields(context, payload) {
          await API.graphql(graphqlOperation(`
            mutation UpdateCompany(
              $input: UpdateCompanyInput!
              $condition: ModelCompanyConditionInput
            ) {
              updateCompany(input: $input, condition: $condition) {
                id
              }
            }
          `, { input: Object.assign({ id: context.state.item.id }, payload.fields )}));
          return context.dispatch('get', { id: context.state.item.id });
          //return r.data.updateDomain;
        },

        async getRegistrarInfo(context, payload) {
          const c = await API.graphql(graphqlOperation(`query GetRegistrarInfo($input: BusinessInfoInput!) {
          businessRegistrarInfo(input: $input) {
                  name
                  street
                  city
                  zip
                  country
                  crNo
                  vatNo
                  vatPayer
            }
          }
              `, { input: payload }));
            return c.data.businessRegistrarInfo;
        },

        async createSubscription(context, payload) {
          const c = await API.graphql(graphqlOperation(`mutation CreateSubscription($input: StripeSubscriptionInput!) {
            createSubscription(input:$input)
          }`, { input: payload }));
          
          return c.data.createSubscription;
        },

        async getStripePortalLink(context, payload) {
          const c = await API.graphql(graphqlOperation(`query GetCompany($id: ID!) {
            getCompany(id: $id) {
              stripePortalLink
            }
          }`, { id: payload.id}));

          return c.data.getCompany.stripePortalLink;
        },

        async changePlan(context, payload) {
          await API.graphql(graphqlOperation(`mutation ChangePlan($input: StripeSubscriptionInput!) {
            changePlan(input:$input)
          }`, { input: payload }));
          
          return context.dispatch('get', { id: context.state.item.id });
        },

        async plans(context, payload) {
          const c = await API.graphql(graphqlOperation(`query GetCompany($id: ID!) {
            getCompany(id: $id) {
              stripePlans
            }
          }`, { id: payload.id}));
          /*
          console.debug('raw plans', c.data.getCompany.stripePlans);
          console.debug('parsed plans', JSON.parse(c.data.getCompany.stripePlans));
          console.debug('parsed parsed plans', JSON.parse(JSON.parse(c.data.getCompany.stripePlans)));
          */
          return JSON.parse(c.data.getCompany.stripePlans);
        },

        // payment information is queried separately due to access rights
        async paymentInformation(context, payload) {
          const c = await API.graphql(graphqlOperation(`query GetCompany($id: ID!) {
            getCompany(id: $id) {
              paymentInformation {
                activePlan
              }
            }
          }`, { id: payload.id}));
          
          return c.data.getCompany.paymentInformation;
        },

        async getBillingHistory(context, payload) {
          const c = await API.graphql(graphqlOperation(`query GetCompany($id: ID!) {
            getCompany(id: $id) {
              history {
                subscription {
                  from
                  to
                  monthlyUserLimit
                }
                stats {
                  monthlyUsers
                  dreamroiSales
                  emailsSent
                }
              }
            }
          }`, { id: payload.id}));
          let m = Object.assign(context.state.item, c.data.getCompany);
          if(!m.history) {
            m.history = [];
          }
          context.commit('item', { value: m });
        }
        
    }
}